import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Minus = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19 12H4.99999",
            stroke: "currentColor",
            strokeWidth: 2 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
